import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { Button, Card, message, Popconfirm, Table } from 'antd';
import React from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import ContentWithErrorHandler from '../../app/ContentWithErrorHandler';
import { basicSort, TableColumnTextFilterConfig } from '../../common/TableHelper';
import { useDeleteCategoryMutation, useGetCategoriesByPoolQuery, useGetPoolQuery } from './lotteryAPI';
import { LotteryCategory } from './lotteryAPI';

function LotteryCategoryList() {
  const navigate = useNavigate();
  const { poolId } = useParams<{ poolId: string }>();
  const poolIdNum = Number(poolId);

  const { data: poolData } = useGetPoolQuery(poolIdNum);
  const { data, error, isLoading } = useGetCategoriesByPoolQuery(poolIdNum);
  const [deleteCategory] = useDeleteCategoryMutation();

  const handleDelete = async (id: number) => {
    try {
      await deleteCategory(id).unwrap();
      message.success('Kategori berhasil dihapus');
    } catch (err: any) {
      message.error(err.data?.message || 'Gagal menghapus kategori');
    }
  };

  return (
    <ContentWithErrorHandler isError={error} isLoading={false}>
      <Card
        title={`Kategori Undian: ${poolData?.name}`}
        size="small"
        extra={
          <div style={{ display: 'flex', gap: '8px' }}>
            <Button type="primary" style={{ borderRadius: 5 }}>
              <Link to={`create`}>+ Tambah Kategori</Link>
            </Button>
            <Button onClick={() => navigate('/lottery/pools')}>Kembali ke Undian</Button>
          </div>
        }
      >
        <Table
          loading={isLoading}
          dataSource={data}
          rowKey="id"
          bordered
          size="small"
          pagination={{ pageSize: 10 }}
          columns={[
            {
              title: 'ID Kategori',
              dataIndex: 'categoryId',
              key: 'categoryId',
              width: '15%',
              sorter: (a, b) => basicSort(a.categoryId, b.categoryId),
              ...TableColumnTextFilterConfig<LotteryCategory>('categoryId'),
            },
            {
              title: 'Nama Kategori',
              dataIndex: 'name',
              key: 'name',
              width: '20%',
              sorter: (a, b) => basicSort(a.name, b.name),
              ...TableColumnTextFilterConfig<LotteryCategory>('name'),
            },
            {
              title: 'Tiket yg akan diberikan',
              dataIndex: 'maxTickets',
              key: 'maxTickets',
              width: '10%',
              sorter: (a, b) => a.maxTickets - b.maxTickets,
            },
            {
              title: 'Deskripsi',
              dataIndex: 'description',
              key: 'description',
              width: '25%',
              sorter: (a, b) => basicSort(a.description || '', b.description || ''),
              render: (description: string) => (
                <div dangerouslySetInnerHTML={{ __html: description || '' }} style={{ wordBreak: 'break-word', whiteSpace: 'normal' }} />
              ),
            },
            {
              title: 'Aktif',
              dataIndex: 'isActive',
              key: 'isActive',
              width: '10%',
              render: (isActive: boolean) => (isActive ? 'Ya' : 'Tidak'),
            },
            {
              title: 'Aksi',
              key: 'actions',
              width: '15%',
              render: (_, record) => (
                <div style={{ display: 'flex', gap: '8px' }}>
                  <Button type="link" icon={<EditOutlined />} onClick={() => navigate(`edit/${record.id}`)} />
                  <Popconfirm title="Hapus Kategori" onConfirm={() => handleDelete(record.id)} okText="Ya" cancelText="Tidak">
                    <Button type="link" danger icon={<DeleteOutlined />} />
                  </Popconfirm>
                </div>
              ),
            },
          ]}
        />
      </Card>
    </ContentWithErrorHandler>
  );
}

export default LotteryCategoryList;
